const COPY = Object.freeze({
  AUTH_REQUIRED: 'Please sign in again.',
  ACCESS_DENIED: 'This action is not available for your account.',
  UPSTREAM_TEMPORARILY_UNAVAILABLE: 'This information is temporarily unavailable. Please check back later.',
  INVALID_REQUEST: 'Please check the information before sending it.',
  HOMEWORK_NOT_EXECUTABLE: 'This Homework cannot be opened in Booster.',
  PRACTICE_NOT_AVAILABLE: 'This practice is not available right now.',
  UPLOAD_INVALID: 'Please check the description and screenshot before sending the report.',
  SERVER_ERROR: 'Something went wrong. Please check back later.',
});

export const publicErrorMessage = (result = {}, fallback = COPY.SERVER_ERROR) => {
  const code = result?.data?.error?.code || result?.error?.code || result?.code;
  if (COPY[code]) return COPY[code];
  const status = Number(result?.status || 0);
  if (status === 401) return COPY.AUTH_REQUIRED;
  if (status === 403) return COPY.ACCESS_DENIED;
  if ([502, 503, 504].includes(status)) return COPY.UPSTREAM_TEMPORARILY_UNAVAILABLE;
  return fallback;
};

export { COPY as PUBLIC_ERROR_COPY };
